import { render, staticRenderFns } from "./dcFooter.vue?vue&type=template&id=6e5d8429&scoped=true&"
import script from "./dcFooter.vue?vue&type=script&lang=js&"
export * from "./dcFooter.vue?vue&type=script&lang=js&"
import style0 from "./dcFooter.vue?vue&type=style&index=0&id=6e5d8429&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5d8429",
  null
  
)

export default component.exports